module.exports = __webpack_public_path__ + "asset/drag-texture--e634cd.svg";